import React from "react";
import PropTypes from "prop-types";

const ContainedButton = ({
  children,
  isLoading = false,
  isFormValid = true, // Default to true so it doesn't disable all buttons
  className,
  style = {},
  type,
  disabled = false,
  ...rest
}) => {
  const isDisabled = disabled || isLoading || !isFormValid;

  return (
    <button
      type={type}
      className={className}
      style={style}
      disabled={isDisabled}
      {...rest}
    >
      {children}
    </button>
  );
};

ContainedButton.propTypes = {
  children: PropTypes.node.isRequired,
  isLoading: PropTypes.bool,
  isFormValid: PropTypes.bool,
  style: PropTypes.object,
};

export default ContainedButton;
